// List all document templates
export const DOCUMENT_TEMPLATE_LIST_REQUEST = 'DOCUMENT_TEMPLATE_LIST_REQUEST';
export const DOCUMENT_TEMPLATE_LIST_SUCCESS = 'DOCUMENT_TEMPLATE_LIST_SUCCESS';
export const DOCUMENT_TEMPLATE_LIST_FAIL = 'DOCUMENT_TEMPLATE_LIST_FAIL';
export const DOCUMENT_TEMPLATE_LIST_RESET = 'DOCUMENT_TEMPLATE_LIST_RESET';

// List document templates by IDs
export const DOCUMENT_TEMPLATE_LIST_BY_IDS_REQUEST = 'DOCUMENT_TEMPLATE_LIST_BY_IDS_REQUEST';
export const DOCUMENT_TEMPLATE_LIST_BY_IDS_SUCCESS = 'DOCUMENT_TEMPLATE_LIST_BY_IDS_SUCCESS';
export const DOCUMENT_TEMPLATE_LIST_BY_IDS_FAIL = 'DOCUMENT_TEMPLATE_LIST_BY_IDS_FAIL';
export const DOCUMENT_TEMPLATE_LIST_BY_IDS_RESET = 'DOCUMENT_TEMPLATE_LIST_BY_IDS_RESET';

// Get document template details
export const DOCUMENT_TEMPLATE_DETAILS_REQUEST = 'DOCUMENT_TEMPLATE_DETAILS_REQUEST';
export const DOCUMENT_TEMPLATE_DETAILS_SUCCESS = 'DOCUMENT_TEMPLATE_DETAILS_SUCCESS';
export const DOCUMENT_TEMPLATE_DETAILS_FAIL = 'DOCUMENT_TEMPLATE_DETAILS_FAIL';
export const DOCUMENT_TEMPLATE_DETAILS_RESET = 'DOCUMENT_TEMPLATE_DETAILS_RESET';

// Create document template
export const DOCUMENT_TEMPLATE_CREATE_REQUEST = 'DOCUMENT_TEMPLATE_CREATE_REQUEST';
export const DOCUMENT_TEMPLATE_CREATE_SUCCESS = 'DOCUMENT_TEMPLATE_CREATE_SUCCESS';
export const DOCUMENT_TEMPLATE_CREATE_FAIL = 'DOCUMENT_TEMPLATE_CREATE_FAIL';
export const DOCUMENT_TEMPLATE_CREATE_RESET = 'DOCUMENT_TEMPLATE_CREATE_RESET';

// Update document template
export const DOCUMENT_TEMPLATE_UPDATE_REQUEST = 'DOCUMENT_TEMPLATE_UPDATE_REQUEST';
export const DOCUMENT_TEMPLATE_UPDATE_SUCCESS = 'DOCUMENT_TEMPLATE_UPDATE_SUCCESS';
export const DOCUMENT_TEMPLATE_UPDATE_FAIL = 'DOCUMENT_TEMPLATE_UPDATE_FAIL';
export const DOCUMENT_TEMPLATE_UPDATE_RESET = 'DOCUMENT_TEMPLATE_UPDATE_RESET';

// Delete document template
export const DOCUMENT_TEMPLATE_DELETE_REQUEST = 'DOCUMENT_TEMPLATE_DELETE_REQUEST';
export const DOCUMENT_TEMPLATE_DELETE_SUCCESS = 'DOCUMENT_TEMPLATE_DELETE_SUCCESS';
export const DOCUMENT_TEMPLATE_DELETE_FAIL = 'DOCUMENT_TEMPLATE_DELETE_FAIL';
export const DOCUMENT_TEMPLATE_DELETE_RESET = 'DOCUMENT_TEMPLATE_DELETE_RESET';

// Load document template DTO
export const DOCUMENT_TEMPLATE_DTO_REQUEST = 'DOCUMENT_TEMPLATE_DTO_REQUEST';
export const DOCUMENT_TEMPLATE_DTO_SUCCESS = 'DOCUMENT_TEMPLATE_DTO_SUCCESS';
export const DOCUMENT_TEMPLATE_DTO_FAIL = 'DOCUMENT_TEMPLATE_DTO_FAIL';
export const DOCUMENT_TEMPLATE_DTO_RESET = 'DOCUMENT_TEMPLATE_DTO_RESET';

// Pagination
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';

// List all public document templates
export const DOCUMENT_TEMPLATE_PUBLIC_LIST_REQUEST = 'DOCUMENT_TEMPLATE_PUBLIC_LIST_REQUEST';
export const DOCUMENT_TEMPLATE_PUBLIC_LIST_SUCCESS = 'DOCUMENT_TEMPLATE_PUBLIC_LIST_SUCCESS';
export const DOCUMENT_TEMPLATE_PUBLIC_LIST_FAIL = 'DOCUMENT_TEMPLATE_PUBLIC_LIST_FAIL';
export const DOCUMENT_TEMPLATE_PUBLIC_LIST_RESET = 'DOCUMENT_TEMPLATE_PUBLIC_LIST_RESET'; 